import React from 'react';

import screeningImage from '../../../../Assets/Linkages/SpaceOutreachFilm/Audience-Screenings.jpg';

const AudienceScreenings = () => (
  <section className="outreach-film-feature" aria-labelledby="audience-screenings-title">
    <div className="outreach-film-feature-inner">
      <figure className="outreach-film-feature-artwork">
        <img
          src={screeningImage}
          alt="Audience attending a Beyond the Blue film screening"
          loading="lazy"
        />
      </figure>

      <div className="outreach-film-feature-copy">
        <p className="section-eyebrow">SCREENINGS · CONVERSATIONS · IMPACT</p>
        <h2 id="audience-screenings-title">Engaging Audiences Through Film Screenings</h2>
        <div className="world-space-week-title-line" aria-hidden="true" />
        <p>
          The film has been screened at a variety of venues, including universities, film festivals,
          and community outreach programs, bringing together students, researchers, and the general
          public. A special screening at the Black Hole drew large audiences and sparked engaging
          discussions on the phenomenon of cloudbursts driven by climate change, underscoring the
          pressing issue of flooding in Pakistan and around the world. Each screening continues to
          broaden the film’s reach, creating opportunities for dialogue on space, climate change, and sustainability.
        </p>
      </div>
    </div>
  </section>
);

export default AudienceScreenings;
